module.exports = "<div>Logout</div>"